<app-about-whatsapp
  *ngIf="showAbout"
  (back)="closeAbout()"
></app-about-whatsapp>

<ng-container *ngIf="!showAbout">
<!-- Header like the provided design. Once connected the switch below is the only
     disconnect affordance on mobile, matching the design. -->
<div
  [class.hidden]="isConnected"
  class="max-w-[858px] bg-[#E3D7FF] rounded-[10.4px] px-5 py-4 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between shadow-sm md:flex"
>
  <div class="text-2xl md:text-[26px] font-extrabold text-black leading-tight">
    Connect WhatsApp
  </div>
  <button
    (click)="onPrimaryAction()"
    [disabled]="loading"
    class="shrink-0 inline-flex items-center justify-center h-12 w-full sm:w-[229px] bg-black text-white text-center rounded-full px-12 text-[15px] leading-[20px] tracking-[1.5px] font-bold shadow-[0_4px_0_0_rgba(0,0,0,0.1)] active:translate-y-[2px] active:shadow-[0_2px_0_0_rgba(0,0,0,0.1)] whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed"
  >
    {{ isConnected ? "Disconnect" : "Connect your number" }}
  </button>
</div>

<!-- Enter number panel -->
<div
  *ngIf="step === 'enterNumber'"
  class="mt-6 max-w-[858px] bg-white rounded-[10.4px] shadow-sm px-5 py-6 flex flex-col gap-4"
>
  <div class="text-[18px] font-bold text-[#1E252B]">Enter your WhatsApp number</div>
  <p class="text-sm text-[#4C4F53]">
    Use the international format, including your country code (e.g. +385911234567).
    We'll send you a confirmation code on WhatsApp.
  </p>
  <input
    type="tel"
    inputmode="tel"
    autocomplete="tel"
    [(ngModel)]="phoneNumber"
    (keyup.enter)="submitNumber()"
    placeholder="+385911234567"
    class="w-full h-12 rounded-full border border-gray-300 px-5 text-base focus:outline-none focus:ring-2 focus:ring-[#857AEF]"
  />

  <p *ngIf="errorMessage" class="text-sm text-red-600">{{ errorMessage }}</p>

  <div class="flex flex-col sm:flex-row gap-3">
    <button
      (click)="submitNumber()"
      [disabled]="loading"
      class="inline-flex items-center justify-center h-12 flex-1 bg-black text-white text-center rounded-full px-12 text-[15px] leading-[20px] tracking-[1.5px] font-bold whitespace-nowrap shadow-[0_4px_0_0_rgba(0,0,0,0.1)] active:translate-y-[2px] active:shadow-[0_2px_0_0_rgba(0,0,0,0.1)] disabled:opacity-60 disabled:cursor-not-allowed"
    >
      {{ loading ? "Sending…" : "Send code" }}
    </button>
    <button
      (click)="cancelFlow()"
      [disabled]="loading"
      class="inline-flex items-center justify-center h-12 flex-1 sm:flex-none sm:w-[140px] bg-white text-black text-center rounded-full px-8 text-[15px] leading-[20px] tracking-[1.5px] font-bold whitespace-nowrap border border-[#2F2A4A] disabled:opacity-60"
    >
      Cancel
    </button>
  </div>
</div>

<!-- Confirm code panel -->
<div
  *ngIf="step === 'confirmCode'"
  class="mt-6 max-w-[858px] bg-white rounded-[10.4px] shadow-sm px-5 py-6 flex flex-col gap-4"
>
  <div class="text-[18px] font-bold text-[#1E252B]">Enter confirmation code</div>
  <p *ngIf="infoMessage" class="text-sm text-[#4C4F53]">{{ infoMessage }}</p>
  <input
    type="text"
    inputmode="numeric"
    autocomplete="one-time-code"
    [(ngModel)]="confirmationCode"
    (keyup.enter)="submitCode()"
    placeholder="Confirmation code"
    class="w-full h-12 rounded-full border border-gray-300 px-5 text-base tracking-[0.3em] focus:outline-none focus:ring-2 focus:ring-[#857AEF]"
  />

  <p *ngIf="errorMessage" class="text-sm text-red-600">{{ errorMessage }}</p>

  <div class="flex flex-col sm:flex-row gap-3">
    <button
      (click)="submitCode()"
      [disabled]="loading"
      class="inline-flex items-center justify-center h-12 flex-1 bg-black text-white text-center rounded-full px-12 text-[15px] leading-[20px] tracking-[1.5px] font-bold whitespace-nowrap shadow-[0_4px_0_0_rgba(0,0,0,0.1)] active:translate-y-[2px] active:shadow-[0_2px_0_0_rgba(0,0,0,0.1)] disabled:opacity-60 disabled:cursor-not-allowed"
    >
      {{ loading ? "Confirming…" : "Confirm" }}
    </button>
    <button
      (click)="cancelFlow()"
      [disabled]="loading"
      class="inline-flex items-center justify-center h-12 flex-1 sm:flex-none sm:w-[140px] bg-white text-black text-center rounded-full px-8 text-[15px] leading-[20px] tracking-[1.5px] font-bold whitespace-nowrap border border-[#2F2A4A] disabled:opacity-60"
    >
      Cancel
    </button>
  </div>

  <button
    (click)="resendCode()"
    [disabled]="loading"
    class="self-start text-sm font-semibold text-[#857AEF] hover:underline disabled:opacity-60"
  >
    Didn't get a code? Resend
  </button>
</div>

<!-- Integration settings (shown on the overview) -->
<div
  *ngIf="step === 'overview'"
  class="mt-6 max-w-[858px] bg-white rounded-[10.4px] shadow-[2px_2px_20px_0px_rgba(0,0,0,0.1)] overflow-hidden py-4 flex flex-col gap-2"
>
  <div
    class="text-center text-[17px] tracking-[2px] text-black uppercase leading-normal"
  >
    WhatsApp Integration
  </div>

  <div class="pt-4 flex flex-col gap-4">
    <!-- Chat with IVY via WhatsApp -->
    <div class="flex items-center gap-[9px] px-4">
      <div class="flex-1 min-w-0">
        <div class="text-[16px] font-medium text-black">
          Chat with IVY via WhatsApp
        </div>
        <a
          *ngIf="isConnected"
          [href]="'tel:' + connectedNumber"
          class="block truncate text-[14px] text-[#7000FF] underline"
          >{{ connectedNumber }}</a
        >
        <div *ngIf="!isConnected" class="text-[14px] text-[#4C4F53]">
          Receive enabled notifications directly through WhatsApp
        </div>
      </div>
      <button
        type="button"
        role="switch"
        aria-label="Chat with IVY via WhatsApp"
        [attr.aria-checked]="whatsappEnabled"
        [disabled]="!isConnected"
        (click)="toggleWhatsapp()"
        class="relative inline-flex h-[31px] w-[51px] shrink-0 items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-60"
        [ngClass]="whatsappEnabled ? 'bg-[#7000FF]' : 'bg-gray-300'"
      >
        <span
          class="inline-block h-[27px] w-[27px] rounded-full bg-white shadow transform transition-transform"
          [ngClass]="whatsappEnabled ? 'translate-x-[22px]' : 'translate-x-[2px]'"
        ></span>
      </button>
    </div>

    <div class="h-px bg-black/10"></div>
  </div>

  <!-- About WhatsApp -->
  <div class="border-b border-black/10">
    <button
      type="button"
      class="w-full flex items-center justify-between gap-4 px-4 py-4 text-left"
      (click)="openAbout()"
    >
      <span class="text-[16px] font-bold text-black leading-6"
        >About WhatsApp</span
      >
      <svg
        class="w-6 h-6 text-black shrink-0"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 5l7 7-7 7"
        />
      </svg>
    </button>
  </div>

  <!-- Error surfaced from toggle actions -->
  <p *ngIf="errorMessage" class="px-4 text-sm text-red-600">{{ errorMessage }}</p>
</div>

<app-disconnect-whatsapp
  [step]="disconnectStep"
  [loading]="loading"
  [errorMessage]="disconnectError"
  (confirm)="onDisconnectConfirm()"
  (cancel)="onDisconnectCancel()"
  (contactSupport)="onContactSupport()"
  (feedback)="onDisconnectFeedback($event)"
></app-disconnect-whatsapp>
</ng-container>
